<template>
  <div v-if="$vuetify.breakpoint.smAndDown">
    <v-bottom-navigation background-color="blue-grey darken-4" dark fixed grow height="70" mandatory v-model="nav">
      <v-btn
        :to="`/${$store.state.merchant.slug}`"
        :color="$route.path === `/${$store.state.merchant.slug}` ? 'primary' : ''"
      >
        <span>Home</span>
        <v-icon>mdi-store</v-icon>
      </v-btn>
      <v-btn
        :to="`/${this.$store.state.merchant.slug}/collections`"
        :color="$route.path === `/${$store.state.merchant.slug}/collections` ? 'primary' : ''"
      >
        <span>Collections</span>
        <v-icon>mdi-view-agenda</v-icon>
      </v-btn>
      <v-btn
        @click="gotoOrder"
        :class="$route.path === `/request/${$store.state.request.slug}` ? 'primary' : ''"
      >
        <span>Order</span>
        <v-icon>mdi-file-document</v-icon>
      </v-btn>
      <v-btn @click="showView('more')">
        <span>More</span>
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <v-bottom-sheet inset max-width="500" v-model="views.more">
      <MoreLinks @close="closeViews()" @view="showView($event)"/>
    </v-bottom-sheet>

    <v-bottom-sheet inset max-width="500" v-model="views.about">
      <About @close="closeViews()"/>
    </v-bottom-sheet>

    <v-bottom-sheet inset max-width="500" v-model="views.referral">
      <Referral @close="closeViews()"/>
    </v-bottom-sheet>

    <v-bottom-sheet inset max-width="500" v-model="views.whatsapp">
      <Whatsapp/>
    </v-bottom-sheet>

    <v-dialog max-width="350" v-model="views.noOrder">
      <v-card>
        <v-card-title>No order found!</v-card-title>
        <v-card-text>
          Please use link sent via email address or whatsapp to view your order
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="views.noOrder = false" color="red darken-1" text>Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import About from "../../views/About";
import Referral from "../referral/Referral";
import MoreLinks from "./MoreLinks";
import views from '../../mixins/views';
import Whatsapp from "./Whatsapp";

export default {
  name: "BottomNavigationStore",
  components: { Whatsapp, MoreLinks, Referral, About },
  mixins: [views],
  data: () => ({
    nav: 0,
    views: {
      about: false,
      referral: false,
      whatsapp: false,
      more: false,
      noOrder: false
    }
  }),
  methods: {
    gotoOrder() {
      if (this.$store.state.request.slug) this.$router.push(`/request/${ this.$store.state.request.slug }`)
      else this.views.noOrder = true;
    }
  }
}
</script>
